import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.DOCTORS_LIST, { params: payload }),
    search: payload => axios.get(HTTP.DOCTORS_SEARCH, { params: { ...payload } })
}
